<template>
  <v-container>
    <v-row justify="center" align="center">
      <v-col cols="12" sm="8" md="6" xl="4">
        <slot></slot>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup lang="ts"></script>
